import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '@shared/services/token.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const tokenService: TokenService = inject(TokenService);
  const router: Router = inject(Router);
  if (tokenService.getToken() !== null) {
    router.navigate(['/panel/dashboard']);
    return false;
  }
  return true;
};
